import { Kaggle } from "@kaggle/sdk";
import { ExternalSourceDataActionKey } from "../../actions/ActionKeys";
import { ExternalSourceDataAction } from "../../actions/externalSourceData";

import ExternalSourceData = Kaggle.Sdk.Kernels.ExternalSourceData;

export function externalSourceData(
  state: ExternalSourceData | null = null,
  action: ExternalSourceDataAction
): ExternalSourceData | null {
  switch (action.type) {
    case ExternalSourceDataActionKey.SET_EXTERNAL_SOURCE_DATA:
      return action.payload.externalSourceData;
    default:
      return state;
  }
}
